import { BlockContent } from '../../components/BlockContent';
import {
  articlePageQuery_articlePage_slugsByLocale,
  TextAlignment
} from '../../core-types';
import { ArticleLayout } from './ArticleLayout';

const Article = ({
  data,
  appContent
}: {
  data:
    | {
        title: string;
        file: CORE_JSON | null;
        heading: string | null;
        intro: CORE_JSON | null;
        introAlignment: TextAlignment | null;
        content: CORE_JSON | null;
        contentAlignment: TextAlignment | null;
        slugsByLocale: articlePageQuery_articlePage_slugsByLocale[] | null;
      }
    | undefined;
  appContent: boolean;
}) => {
  if (!data) {
    return null;
  }
  const { intro, introAlignment, content, contentAlignment, file } = data;
  const heading = data.heading || data.title;

  return (
    <ArticleLayout
      appContent={appContent}
      heading={heading}
      intro={
        intro && (
          <BlockContent
            blocks={intro}
            withoutAnchors={appContent}
            textAlign={introAlignment || undefined}
          />
        )
      }
      content={
        content && (
          <BlockContent
            blocks={content}
            withoutAnchors={appContent}
            textAlign={contentAlignment || undefined}
          />
        )
      }
      file={file || null}
    />
  );
};

export default Article;
